import React from "react";
import Dashboard from "../../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import DataServices from "../../@Components/Data/DataServices";

const DataServicesReport: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <DataServices />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default DataServicesReport;
